import createJshook from './createJshook'

// Singleton version
export default createJshook()

// Factory version
export { createJshook }



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/